import React from 'react';
import Icon from './icon';

export default props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM7.75488 11.2793C8.25998 11.2793 8.67383 11.6664 8.67383 12.1396C8.67379 12.6128 8.25996 13 7.75488 13C7.24991 12.9999 6.83695 12.6128 6.83691 12.1396C6.83691 11.6665 7.24988 11.2794 7.75488 11.2793ZM8.04102 3C9.83674 3.00008 10.9999 4.08982 11 5.58105C11 6.63746 10.4692 7.37427 9.57129 7.88574C8.67356 8.41149 8.34658 8.92795 8.32617 10.1133V10.1699L7.10156 10.1699V10.1133C7.11687 8.29217 7.71398 7.73676 8.71387 7.16797C9.31081 6.82858 9.77539 6.28348 9.77539 5.52344C9.77514 4.58687 8.99995 3.99422 8.04102 3.99414C7.20434 3.99414 6.36276 4.45312 6.28613 5.58105H5C5.07663 3.95594 6.38802 3 8.04102 3Z"
      fill="currentcolor"
    />
  </Icon>
);
